import React, { useState, useEffect } from "react";
import Logo from "../assets/belleepoque_logo.png";
import PopUp from "../components/PopUp";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false); // For mobile menu
  const [isModalOpen, setIsModalOpen] = useState(false); // For modal
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // For desktop dropdown menu
  const [isMobileSubmenuOpen, setIsMobileSubmenuOpen] = useState(false); // For mobile submenu
  const [showSecondaryPopup, setShowSecondaryPopup] = useState(false); // For secondary popup

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const toggleMobileSubmenu = () => {
    setIsMobileSubmenuOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  // Automatically close secondary popup after 5 seconds
  useEffect(() => {
    if (showSecondaryPopup) {
      const timeout = setTimeout(() => {
        setShowSecondaryPopup(false);
      }, 3000); // 3 seconds

      return () => clearTimeout(timeout); // Clear timeout on unmount
    }
  }, [showSecondaryPopup]);

  return (
    <header className="bg-white shadow-sm fixed top-0 left-0 w-full z-50 border-b border-gray-300">
      <div className="max-w-7xl mx-auto flex justify-between items-center px-4 md:px-16 py-1">
        {/* Logo */}
        <img src={Logo} className="ml-10" style={{width: "74.89px", height: "60px"}} alt="Logo" />

        {/* Desktop Navigation */}
        <nav className="hidden md:flex ml-auto">
          <div className="flex items-center space-x-1">
            {[
              {
                name: "Marque a sua viagem!",
                url: "https://belleepoque.geaweb.pt/",
              },
              { name: "Peça o seu orçamento!", action: toggleModal },
              { name: "Quem Somos", id: "about" },
              { name: "Contatos", id: "contact" },
            ].map((item) => (
              <div key={item.name} className="relative">
                <a
                  href={item.url || "#"}
                  onClick={
                    item.action
                      ? (e) => {
                          e.preventDefault();
                          item.action();
                        }
                      : item.id
                      ? (e) => {
                          e.preventDefault();
                          scrollToSection(item.id);
                        }
                      : undefined
                  }
                  className="font-bold text-md transition duration-300 inline-block no-underline text-cyan-700 py-2 pb-3"
                  target={item.url ? "_blank" : "_self"}
                  rel={item.url ? "noopener noreferrer" : undefined}
                >
                  {item.name}
                </a>
              </div>
            ))}

            {/* Dropdown Menu */}
            <div className="relative">
              <button
                className="font-bold text-md text-cyan-700 px-3 rounded-lg transition pb-2"
                onClick={toggleDropdown}
              >
                Links Úteis
              </button>
              {isDropdownOpen && (
                <div
                  className="absolute bg-white shadow-lg border border-gray-200 rounded-lg mt-2 w-48 z-10"
                  onClick={(e) => e.stopPropagation()}
                >
                  <li>
                    <a
                      href="https://portaldascomunidades.mne.gov.pt/pt/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 font-bold text-md text-cyan-700 hover:text-cyan-500 no-underline"
                    >
                      Portal das Comunidades
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.traveldoc.aero/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 font-bold text-md text-cyan-700 hover:text-cyan-500 no-underline"
                    >
                      TravelDoc
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://esta.cbp.dhs.gov/esta"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 font-bold text-md text-cyan-700 hover:text-cyan-500 no-underline"
                    >
                      ESTA
                    </a>
                  </li>
                </div>
              )}
            </div>
          </div>
        </nav>

        {/* Mobile Menu Icon */}
        <button className="md:hidden z-50" onClick={toggleMenu}>
          <svg
            className={`w-6 h-6 ${isOpen ? "text-white" : "text-cyan-600"}`} // Changes color dynamically
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16m-7 6h7"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`fixed top-0 left-0 w-full z-40 transform ${
          isOpen ? "translate-y-0" : "-translate-y-full"
        } transition-transform duration-300`}
      >
        <ul className="pl-0 flex flex-col items-center py-3 bg-cyan-600 border border-gray-300 rounded-lg shadow-lg mx-auto max-w-sm">
          {[
            {
              name: "Marque a sua viagem!",
              url: "https://belleepoque.geaweb.pt/",
            },
            { name: "Peça o seu orçamento!", action: toggleModal },
            { name: "Quem Somos", id: "about" },
            { name: "Contatos", id: "contact" },
          ].map((item, index) => (
            <li
              key={item.name}
              className={`w-full text-center py-3 ${
                index < 3 ? "border-b border-gray-300" : ""
              }`}
            >
              <a
                href={item.url || "#"}
                onClick={
                  item.action
                    ? (e) => {
                        e.preventDefault();
                        item.action();
                      }
                    : item.id
                    ? () => scrollToSection(item.id)
                    : undefined
                }
                className="text-white font-semibold text-lg no-underline"
              >
                {item.name}
              </a>
            </li>
          ))}

          <li
            onClick={toggleMobileSubmenu}
            className="w-full text-center py-3 border-t border-gray-300 px-4"
          >
            {/* Links Úteis Mobile Menu */}
            <a className="text-white font-semibold text-lg no-underline cursor-pointer">
              Links Úteis
            </a>
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                isMobileSubmenuOpen
                  ? "max-h-[500px] opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <ul className="pt-2 pb-2 pl-0 mt-3 bg-gray-50 rounded-lg shadow-inner w-full">
                {[
                  {
                    name: "Portal das Comunidades",
                    url: "https://portaldascomunidades.mne.gov.pt/pt/",
                  },
                  {
                    name: "TravelDoc",
                    url: "https://www.traveldoc.aero/",
                  },
                  {
                    name: "ESTA",
                    url: "https://esta.cbp.dhs.gov/esta",
                  },
                ].map((submenuItem) => (
                  <li
                    key={submenuItem.name}
                    className="py-2 text-center"
                  >
                    <a
                      href={submenuItem.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-cyan-700 font-semibold text-md hover:text-cyan-500 no-underline"
                    >
                      {submenuItem.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        </ul>
      </div>

      {/* Modal Popup */}
      <PopUp
        setShowSecondaryPopup={setShowSecondaryPopup}
        isOpen={isModalOpen}
        onClose={toggleModal}
      />

      {/* Secondary Popup */}
      {showSecondaryPopup && (
        <div className="fixed top-16 inset-x-0 flex justify-center z-50">
          <div className="bg-cyan-600 px-6 py-2 rounded-lg shadow-lg border border-gray-300">
            <p className="text-white pt-4">Obrigado pelo seu contato!</p>
            <p className="text-white">
              Brevemente, entraremos em contato consigo!
            </p>
          </div>
        </div>
      )}

      {/* Close dropdown when clicking outside */}
      {isDropdownOpen && (
        <div className="fixed inset-0" onClick={closeDropdown}></div>
      )}
    </header>
  );
};

export default Header;
